<button [class]="'items-center py-3 text-white text-center rounded-full button-primary ' + (extraClasses || 'w-[228px]')"
    [disabled]="isDisabled"
    [ngClass]="{'bg-gray-300  cursor-not-allowed': isDisabled, 'cursor-pointer': !isDisabled}" 
    [ngStyle]="{'background-color': backgroundColor}" 
    (click)="click()"
    >
    <span>{{ text }}</span>
</button>